<template>
  <small v-if="hasDescription" :id="descriptionId" class="form-text text-muted">
    <span v-html="description"></span>
  </small>
</template>

<script>
export default {
  name: "BaseControlDescription",
  props: {
    id: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ""
    }
  },
  computed: {
    hasDescription() {
      return this.description.length > 0;
    },
    descriptionId() {
      return `${this.id}_text`;
    }
  }
};
</script>
